<template>
    <div>
        <AppBreadCrumb
            :paths="[{ title: $t('billing.invoiceManagement') }]"
            :select="true"
            :showChatbotSession="true"
        />
        <UpdateCardModal v-if="updatingCard" @cancel="updatingCard = false" @create="updateCard" />
        <UpdateBillingModal v-if="updatingBilling" @cancel="updatingBilling = false" @create="updateBilling" />
        <TrialSkipModal v-if="trialSkipModal" @reject="trialSkipModal = false" @confirm="skipTrial" />
        <CreateInvoiceModal v-if="billModal" @cancel="billModal = false" @create="createInvoice" />
        <div id="billing">
            <div class="trial-information" v-if="trialInfo.remainingDays > 0">
                <div class="information">
                    <span class="material-icons">lightbulb</span>
                    Şuan deneme sürümündesiniz. Ayrıcalıklı paketleri görmek için deneme sürümünü hemen
                    atlayabilirsiniz.
                </div>
                <div class="skip-now" @click="trialSkipModal = true">Hemen Atla</div>
            </div>
            <div class="trial-information absolute-top" v-if="shouldSelectPlan.enabled">
                <span class="material-icons alert-icon">notification_important</span>
                <div class="information">
                    <div class="information-message">
                        Şuan sistem tarafından paketleriniz koşulları sağlanmadığı için sınırlandırıldınız.
                    </div>
                    <div class="information-details">
                        <div class="information-detail" v-if="shouldSelectPlan.supsisPackage">
                            <div class="information-detail-text">
                                - Toplam <b>{{ shouldSelectPlan.details.current.users }}</b> Adet Temsilciniz
                                bulunmaktadır.
                                <b>{{
                                    shouldSelectPlan.details.current.users -
                                    shouldSelectPlan.details.limit.currentSupsisAgentCount
                                }}</b>
                                Adet Temsilcinizi devre dışı bırakınız veya siliniz veya temsilci satın alınız.
                            </div>
                        </div>
                        <div class="information-detail" v-if="shouldSelectPlan.whatsappQr">
                            <div class="information-detail-text">
                                - Toplam <b>{{ shouldSelectPlan.details.current.whatsappQr }}</b> Adet Whatsapp QR
                                kanalınız bulunmaktadır.
                                <b>
                                    {{
                                        shouldSelectPlan.details.current.whatsappQr -
                                        shouldSelectPlan.details.limit.currentWhatsappPlanCount
                                    }}</b
                                >
                                Adet Whatsapp QR kanalınızı siliniz veya kanal satın alınız.
                            </div>
                        </div>
                        <div class="information-detail" v-if="shouldSelectPlan.whatsappBusiness">
                            <div class="information-detail-text">
                                - Toplam <b>{{ shouldSelectPlan.details.current.whatsappBusinessChannels }}</b> Adet
                                Whatsapp Business kanalınız bulunmaktadır.
                                <b>
                                    {{
                                        shouldSelectPlan.details.current.whatsappBusinessChannels -
                                        shouldSelectPlan.details.limit.currentWhatsappBusinessChannelCount
                                    }}</b
                                >
                                Adet Whatsapp Business kanalınızı siliniz veya kanal satın alınız.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="billing-section">
                <div class="title-head" @click="toggleCollopes('currentPlan')">
                    <div class="title">Mevcut Paketler</div>
                    <div class="collopse">
                        <div class="material-icons">
                            {{ collopes["currentPlan"] ? "arrow_right" : "arrow_drop_down" }}
                        </div>
                    </div>
                </div>
                <div class="content" :class="{ closed: collopes['currentPlan'] }">
                    <CurrentPlans @show="showPlans" :class="'current-plans'" />
                </div>
            </div>
            <div class="billing-section">
                <div class="title-head" @click="toggleCollopes('additional')">
                    <div class="title">Ek Paketler</div>
                    <div class="collopse">
                        <div class="material-icons">
                            {{ collopes["additional"] ? "arrow_right" : "arrow_drop_down" }}
                        </div>
                    </div>
                </div>
                <div class="content" :class="{ closed: collopes['additional'] }">
                    <Features :class="'feature-items'" />
                </div>
            </div>
            <div class="billing-section">
                <div class="title-head" @click="toggleCollopes('invoiceDetail')">
                    <div class="title">Fatura Bilgileri</div>
                    <div class="collopse">
                        <div class="material-icons">
                            {{ collopes["invoiceDetail"] ? "arrow_right" : "arrow_drop_down" }}
                        </div>
                    </div>
                </div>
                <div class="content" :class="{ closed: collopes['invoiceDetail'] }">
                    <div class="invoice-details">
                        <div class="billing-section" style="">
                            <div class="content" style="width: 100%">
                                <div class="card">
                                    <div class="title">{{ $t("message.billingAddress") }}</div>
                                    <div class="bills-content">
                                        <div class="bills">
                                            <div
                                                v-if="billingDetail && billingDetail.billingAddress"
                                                class="bill"
                                                style="
                                                    display: flex;
                                                    align-items: top;
                                                    justify-content: space-between;
                                                    padding: 20px 0px;
                                                "
                                            >
                                                <div style="padding-right: 30px">
                                                    <div style="font-weight: bold">
                                                        {{
                                                            billingDetail.billingType == "company"
                                                                ? billingDetail.name
                                                                : billingDetail.name + " " + billingDetail.surname
                                                        }}
                                                    </div>
                                                    <div>
                                                        {{ billingDetail.billingAddress }} -
                                                        {{ billingDetail.billingCountry }}/{{
                                                            billingDetail.billingCity
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <button @click="updatingBilling = true" class="supsis-ghost-button">
                                                <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                    edit
                                                </span>
                                                {{
                                                    billingDetail && billingDetail.billingAddress
                                                        ? $t("message.edit")
                                                        : $t("message.addNewAddress")
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="billing-section" style="width: 100%">
                            <div class="content" style="width: 100%">
                                <div class="card">
                                    <div class="title">
                                        {{ $t("billing.paymentMethod") }}
                                        <div class="iyzico-pay">
                                            <IyzicoPay />
                                        </div>
                                    </div>
                                    <div class="bills-content">
                                        <div class="bills">
                                            <div
                                                v-if="billingDetail && billingDetail.binNumber"
                                                class="bill"
                                                style="
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: space-between;
                                                    padding: 20px 0px;
                                                "
                                            >
                                                <div style="padding-right: 30px">
                                                    <div style="display: flex; align-items: top">
                                                        <div class="payment-method">
                                                            <DynamicSvg
                                                                :name="formatCardType(billingDetail.cardAssociation)"
                                                            />
                                                        </div>
                                                        <div>
                                                            <div style="font-weight: bold">
                                                                {{ formatCardNumber(billingDetail.binNumber) }}
                                                            </div>
                                                            <div style="color: rgb(160, 160, 160)">
                                                                {{ formatCardType(billingDetail.cardAssociation) }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                @click="updatingCard = true"
                                                class="supsis-ghost-button"
                                                :disabled="billingDetail && !billingDetail.name"
                                            >
                                                <span
                                                    v-if="billingDetail && billingDetail.name"
                                                    class="material-icons"
                                                    style="font-size: 16px; margin-right: 5px"
                                                >
                                                    edit
                                                </span>
                                                {{
                                                    billingDetail && billingDetail.name
                                                        ? billingDetail && billingDetail.binNumber
                                                            ? $t("message.edit")
                                                            : $t("billing.newPaymentMethod")
                                                        : "Fatura Adresini Giriniz!"
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="billing-section" v-if="forecastDetails">
                <div class="title-head" @click="toggleCollopes('futureInvoice')">
                    <div class="title">{{ $t("billing.futureInvoice") }}</div>
                    <div class="collopse">
                        <div class="material-icons">
                            {{ collopes["futureInvoice"] ? "arrow_right" : "arrow_drop_down" }}
                        </div>
                    </div>
                </div>
                <div class="content" :class="{ closed: collopes['futureInvoice'] }">
                    <div class="card">
                        <div class="title">
                            <div>
                                {{ $t("billing.futureInvoice") }}
                                <span style="font-size: 18px">({{ forecastDetails.invoiceDate }})</span>
                            </div>
                        </div>
                        <div class="bills-content">
                            <div class="running-invoice">
                                <div class="running-invoice-detail">
                                    <div>
                                        <div class="running-invoice-detail-title">
                                            {{ $t("billing.invoicePeriod") }}
                                        </div>
                                        <div>{{ forecastDetails.dateBetween }}</div>
                                    </div>
                                    <div>
                                        <div class="running-invoice-detail-title">
                                            {{ $t("billing.invoiceStatus") }}
                                        </div>
                                        <div>{{ $t("billing.expected") }}</div>
                                    </div>
                                    <div>
                                        <div class="running-invoice-detail-title">{{ $t("billing.creationDate") }}</div>
                                        <div>{{ forecastDetails.leftTime }}</div>
                                    </div>
                                </div>
                                <div class="running-invoice-price-details">
                                    <div class="running-invoice-price-detail">
                                        <div class="running-invoice-detail-title">
                                            {{ $t("billing.monthlyEstimatedAmount") }}
                                        </div>
                                        <div class="price">
                                            <MoneyFormatter :price="forecastDetails.endOfMonthForecast" />
                                        </div>
                                        <div style="margin-top: 10px">
                                            <SupsisButton ghost small @click="showForecastDetails('endOfMonthForecast')"
                                                >Detayları Görüntüle
                                            </SupsisButton>
                                        </div>
                                    </div>
                                    <div class="running-invoice-price-detail">
                                        <div class="running-invoice-detail-title">
                                            {{ $t("billing.currentAmount") }}
                                        </div>
                                        <div class="price">
                                            <MoneyFormatter :price="forecastDetails.untilToday" />
                                        </div>
                                        <div style="margin-top: 10px">
                                            <SupsisButton ghost small @click="showForecastDetails('untilToday')"
                                                >Detayları Görüntüle
                                            </SupsisButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="running-invoice-details"
                                v-if="showRunningInvoiceDetails"
                                :class="{ closed: !showRunningInvoiceDetails }"
                            >
                                <div class="running-invoice-details-title">
                                    {{
                                        showRunningInvoiceDetails === "untilToday"
                                            ? "Mevcut Tutar Detayları"
                                            : "Ay Sonu Tahmini Detayları"
                                    }}
                                </div>
                                <div class="detail-content" v-for="plan of forecastDetails.details">
                                    <div class="sub-item-detail zebra">
                                        <div class="sub-item-name">
                                            {{
                                                title[plan.type] ||
                                                plan.type
                                                    .split("-")
                                                    .map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase())
                                                    .join(" ")
                                            }}
                                            <span v-if="isFeature(plan)"> (Özellik) </span>
                                        </div>
                                        <div class="sub-item-price">{{ ~~(plan.totalPrice.price || 0) }}₺</div>
                                    </div>
                                    <div>
                                        <div class="detail-content-child" v-for="detail of Object.values(plan.details)">
                                            <div class="sub-item-detail">
                                                <div class="sub-item-child-name">
                                                    <span>
                                                        - {{ detail.plan.title }} {{ detail.plan.altTitle }}
                                                        {{
                                                            detail.plan.type == "supsis"
                                                                ? `(${detail.planAction.details.agentCount} Agent) ${
                                                                      getFreeAgentCount(detail.plan.features)
                                                                          ? `(+${getFreeAgentCount(
                                                                                detail.plan.features
                                                                            )} Ücretsiz)`
                                                                          : ""
                                                                  }`
                                                                : detail.plan.type == "whatsapp" ||
                                                                  detail.plan.type == "whatsap-business"
                                                                ? `(${detail.planAction.details.whatsappChannel} Whatsapp Kanal)`
                                                                : ""
                                                        }}
                                                    </span>
                                                    {{
                                                        detail.plan.type === "extra-package"
                                                            ? `(${detail.sessionCount} Session)`
                                                            : `${detail.startDate} - ${detail.endDate}`
                                                    }}
                                                </div>
                                                <div class="sub-item-child-price">
                                                    {{
                                                        plan.type == "chatbot"
                                                            ? `${detail.sessionCount} Session`
                                                            : (detail.price || 0) > 0
                                                            ? `${seperateWithCommas((detail.price || 0).toFixed(2))}₺`
                                                            : `0₺`
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style="
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-end;
                                        justify-content: flex-end;
                                        margin-top: 20px;
                                        gap: 10px;
                                    "
                                >
                                    <div style="text-align: right">
                                        <div style="font-weight: bold; font-size: 14px">Toplam Tutar</div>
                                        <div style="font-weight: bold; font-size: 20px">
                                            {{ getPriceDetail().price }}₺
                                        </div>
                                    </div>
                                    <div style="text-align: right">
                                        <div style="font-weight: bold; font-size: 15px">KDV Tutar (%20)</div>
                                        <div style="font-weight: bold; font-size: 20px">
                                            {{ getPriceDetail().kdvPrice }}₺
                                        </div>
                                    </div>
                                    <div style="text-align: right">
                                        <div style="font-weight: bold; font-size: 14px">KDV Dahil Toplam Tutar</div>
                                        <div style="font-weight: bold; font-size: 20px">
                                            {{ getPriceDetail().totalPrice }}₺
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="showRunningInvoiceDetails"
                                style="
                                    margin-top: 20px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    font-size: 18px;
                                "
                                @click="showRunningInvoiceDetails = null"
                            >
                                Hide Details
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="billing-section">
                <div class="title-head" @click="toggleCollopes('invoices')">
                    <div class="title">{{ $t("billing.pastInvoices") }}</div>
                    <div class="collopse">
                        <div class="material-icons">
                            {{ collopes["invoices"] ? "arrow_right" : "arrow_drop_down" }}
                        </div>
                    </div>
                </div>
                <div class="content" :class="{ closed: collopes['invoices'] }">
                    <div class="card">
                        <div class="bills-content">
                            <div class="bill-table">
                                <div
                                    class="table-head"
                                    style="
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                        padding-top: 20px;
                                    "
                                >
                                    <div>
                                        <div class="bill-search" v-if="isAdmin" @click="createBillModal">
                                            <div class="material-icons">add</div>
                                            Fatura Oluştur
                                        </div>
                                    </div>
                                    <div><span class="material-icons"> download </span></div>
                                </div>

                                <a-table :columns="columns" :data-source="invoices" :row-selection="rowSelection">
                                    <div class="d-flex align-items-center" slot="paid" slot-scope="text, record">
                                        <div
                                            v-if="record.paid && !record.refund"
                                            style="
                                                background: green;
                                                width: 10px;
                                                height: 10px;
                                                border-radius: 100px;
                                                margin-right: 5px;
                                            "
                                        ></div>
                                        <div
                                            v-else-if="record.refund"
                                            style="
                                                background: yellow;
                                                width: 10px;
                                                height: 10px;
                                                border-radius: 100px;
                                                margin-right: 5px;
                                            "
                                        ></div>
                                        <div
                                            v-else
                                            style="
                                                background: red;
                                                width: 10px;
                                                height: 10px;
                                                border-radius: 100px;
                                                margin-right: 5px;
                                            "
                                        ></div>
                                        <div>
                                            {{
                                                record.paid && !record.refund
                                                    ? `${$t("billing.paid")}`
                                                    : record.refund
                                                    ? `Geri Ödeme Yapıldı`
                                                    : `${$t("billing.unPaid")}`
                                            }}
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center" slot="_id" slot-scope="text, record">
                                        {{ record._id.slice(12) }}
                                    </div>
                                    <div class="d-flex align-items-center" slot="price" slot-scope="text, record">
                                        <MoneyFormatter :price="record.price" />
                                    </div>
                                    <div class="d-flex align-items-center" slot="createdDate" slot-scope="text, record">
                                        {{ formatDate(record.createdDate) }}
                                    </div>
                                    <div
                                        style="display: flex; align-items: center; justify-content: flex-end"
                                        slot="isViewing"
                                        slot-scope="text, record"
                                    >
                                        <a
                                            v-if="record.pdf"
                                            :href="'https://static.supsis.live/' + record.pdf"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                margin-right: 10px;
                                                user-select: none;
                                                cursor: pointer;
                                                color: black;
                                                text-decoration: none;
                                            "
                                            target="”_blank”"
                                            :download="record.pdf.split('/').pop()"
                                        >
                                            <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                download
                                            </span>
                                            Fatura
                                        </a>
                                        <div
                                            @click="$router.push(`/billing/invoice/${record._id}`)"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                margin-right: 10px;
                                                user-select: none;
                                                cursor: pointer;
                                            "
                                        >
                                            <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                visibility
                                            </span>
                                            İncele
                                        </div>

                                        <div
                                            @click="paymentBill(record._id)"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                margin-right: 10px;
                                                user-select: none;
                                                cursor: pointer;
                                            "
                                            v-if="!record.paid"
                                        >
                                            <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                paid
                                            </span>
                                            Hemen Öde
                                        </div>
                                        <div
                                            @click="deleteInvoice(record._id)"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                margin-right: 10px;
                                                user-select: none;
                                                cursor: pointer;
                                            "
                                            v-if="isAdmin"
                                        >
                                            <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                delete
                                            </span>
                                            Sil
                                        </div>
                                        <div
                                            @click="refundInvoice(record._id)"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                margin-right: 10px;
                                                user-select: none;
                                                cursor: pointer;
                                            "
                                            v-if="isAdmin && record.paid && !record.refund"
                                        >
                                            <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                payments
                                            </span>
                                            Geri Öde
                                        </div>
                                        <div
                                            @click="markPaidBill(record._id)"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                user-select: none;
                                                cursor: pointer;
                                            "
                                            v-if="isAdmin && !record.paid && !record.refund"
                                        >
                                            <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                payments
                                            </span>
                                            Ödendi
                                        </div>
                                        <a-popconfirm
                                            v-if="isAdmin"
                                            placement="bottomRight"
                                            ok-text="Onayla"
                                            cancelText="İptal"
                                            @confirm="updateInvoicePrice(record)"
                                        >
                                            <a-icon slot="icon" type="question-circle-o" style="display: none" />
                                            <template slot="title">
                                                <a-input-number v-model="invoicePrice" />
                                            </template>
                                            <div
                                                style="
                                                    display: flex;
                                                    align-items: center;
                                                    user-select: none;
                                                    cursor: pointer;
                                                "
                                            >
                                                <span class="material-icons" style="font-size: 16px; margin-right: 5px">
                                                    payments
                                                </span>
                                                Fiyat Düzenle
                                            </div>
                                        </a-popconfirm>
                                    </div>
                                </a-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { filter, map } from "rxjs/operators";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment";
import DynamicSvg from "../../../components/DynamicSvg.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import CurrentPlanCard from "../../../components/billing/CurrentPlanCard.vue";
import UpdateCardModal from "../../../components/billing/UpdateCardModal.vue";
import CreateInvoiceModal from "../../../components/billing/CreateInvoiceModal.vue";
import UpdateBillingModal from "../../../components/billing/UpdateBillingModal.vue";
import TrialSkipModal from "./components/TrialSkipModal.vue";
import { skipTrialDays } from "../../../api/site";
import _ from "lodash";
import IyzicoPay from "../../../components/svg/IyzicoPay";
import { sendSocketMessage } from "../../../utils/socketStream";
import {
    createInvoice,
    delInvoice,
    forceDeleteInvoice,
    getInvoices,
    markInvoiceAsPaid,
    refundInvoice,
    takePayment,
    updateBilling,
    updateInvoice,
} from "../../../api/billing";
import MoneyFormatter from "../../../components/MoneyFormatter.vue";
import CurrentPlans from "./components/CurrentPlans.vue";
import FeatureCard from "./components/FeatureCard.vue";
import { i18n } from "../../../language";
import Features from "./components/Features.vue";
import SupsisButton from "../Settings/components/SupsisButton.vue";

const columns = [
    {
        title: i18n.t("message.date"),
        dataIndex: "createdDate",
        key: "createdDate",
        scopedSlots: { customRender: "createdDate" },
    },
    { title: i18n.t("billing.invoiceID"), dataIndex: "_id", key: "_id", scopedSlots: { customRender: "_id" } },
    { title: i18n.t("billing.amount"), dataIndex: "price", key: "price", scopedSlots: { customRender: "price" } },
    { title: i18n.t("billing.paymentStatus"), dataIndex: "paid", key: "paid", scopedSlots: { customRender: "paid" } },
    { title: "", dataIndex: "isViewing", key: "isViewing", scopedSlots: { customRender: "isViewing" } },
];

export default {
    name: "NewBilling",
    components: {
        SupsisButton,
        DynamicSvg,
        AppBreadCrumb,
        CurrentPlanCard,
        UpdateCardModal,
        UpdateBillingModal,
        TrialSkipModal,
        IyzicoPay,
        CreateInvoiceModal,
        MoneyFormatter,
        CurrentPlans,
        FeatureCard,
        Features,
    },
    data() {
        return {
            columns,
            selectedRows: [],
            rowSelection: {
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRows = [...selectedRows];
                },
            },
            site: {},
            invoices: [],
            updatingCard: false,
            updatingBilling: false,
            trialSkipModal: false,
            runningInvoice: {},
            forecastDetails: null,
            showRunningInvoiceDetails: false,
            title: {
                supsis: "Live Support",
                chatbot: "Chatbot",
                instagram: "Instagram",
                whatsapp: "Whatsapp",
                telegram: "Telegram",
            },
            billModal: false,
            collopes: {
                currentPlan: false,
                additional: false,
                invoiceDetail: false,
                futureInvoice: false,
                invoices: false,
            },
            invoicePrice: 0,
            subscriptionModal: null,
        };
    },
    mounted() {
        this.site = this.authSite;
        this.loading = false;
        this.fetchInvoices();
        this.sub = SYSTEM_PUBSUB.stream
            .pipe(
                filter((x) => x.type === SYSTEM_PUBSUB.MESSAGE_TYPES.INVOICE_CREATED),
                map((x) => x.payload)
            )
            .subscribe(() => this.fetchInvoices());

        this.getForecastDetails();
    },
    methods: {
        ...mapMutations({
            setBillingDetail: "site/SET_BILLING_DETAIL",
        }),
        ...mapActions({
            updateCardInfo: "site/updateCardInfo",
            setSettings: "setting/setSettings",
            updateSettings: "setting/updateSettings",
            getSitePlans: "site/getSitePlans",
            getRunningInvoice: "site/getRunningInvoice",
            getSiteCurrentPlans: "site/getSiteCurrentPlans",
            getSiteFeatures: "site/getSiteFeatures",
            getConversationStatistics: "site/getConversationStatistics",
            setSettingValue: "setting/setSettingValue",
        }),
        createBillModal() {
            this.billModal = true;
        },
        toggleCollopes(type) {
            this.collopes[type] = !this.collopes[type];
        },
        async skipTrial() {
            skipTrialDays().then(() => {
                this.setSettingValue([
                    {
                        setting: "plan.trialDays",
                        value: this.settings.plan.trialDays - this.trialInfo.remainingDays,
                    },
                ]);
                this.updateSettings({}).then(() => {
                    Promise.all([
                        this.getSitePlans(),
                        this.getSiteCurrentPlans(),
                        this.getSiteFeatures(),
                        this.getConversationStatistics(),
                    ]).then(() => {
                        this.trialSkipModal = false;
                    });
                    sendSocketMessage("admin settings-updated", {
                        siteId: this.siteId,
                    });
                });
            });
        },
        showPlans(type) {
            this.$router.push({
                path: `/billing/plans/${type}`,
            });
        },
        seperateWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatCardNumber(binNumber) {
            return binNumber.padEnd(16, "•");
        },
        formatDate(date) {
            return moment(date).format("YYYY/MM/DD");
        },
        getFreeAgentCount(features) {
            const feature = features.find((feature) => feature.type === "agent");
            return feature && feature.freeAgentCount;
        },
        getForecastDetails() {
            this.getRunningInvoice().then((runningInvoice) => {
                this.runningInvoice = runningInvoice;
                this.formatForecastDetails();
            });
        },
        formatForecastDetails() {
            let result = {};
            if (this.showRunningInvoiceDetails) {
                const details = this.runningInvoice?.[this.showRunningInvoiceDetails]?.details;
                if (details) {
                    const timeBuckets = details.timeBuckets;
                    result = Object.keys(timeBuckets).map((type) => {
                        const bucketDetails = timeBuckets[type].reduce((acc, bucket, index) => {
                            const planAction = details.planActions[bucket.planActionId];
                            const bucketDetail = bucket?.details || {};
                            const startDate = this.$moment(bucket.date).format("MMM DD YYYY");
                            const endDate = bucket.date && this.$moment(bucket.date).format("MMM DD YYYY");

                            if (planAction.target.type === "extra-package") {
                                acc[planAction.data._id] = {
                                    plan: planAction.target,
                                    planAction: planAction.data,
                                    sessionCount: planAction.target.features[0].maxSessionCount,
                                    price:
                                        ((acc[planAction.data._id] || {}).price || 0) + bucketDetail.acceptPrice || 0,
                                };
                            } else {
                                acc[planAction.data._id] = {
                                    plan: planAction.target,
                                    planAction: planAction.data,
                                    sessionCount:
                                        ((acc[planAction.data._id] || {}).sessionCount || 0) +
                                            bucketDetail.todayUsageSessionCount || 0,
                                    price:
                                        ((acc[planAction.data._id] || {}).price || 0) + bucketDetail.acceptPrice || 0,
                                    startDate: acc[planAction.data._id]
                                        ? acc[planAction.data._id].startDate
                                        : `${startDate}`,
                                    endDate:
                                        (((timeBuckets[type][index + 1] &&
                                            timeBuckets[type][index + 1].planActionId !== planAction.data._id) ||
                                            timeBuckets[type].length == index + 1) &&
                                            endDate) ||
                                        "",
                                };
                            }

                            return acc;
                        }, {});
                        return {
                            type,
                            totalPrice: details.priceDetail[type],
                            details: bucketDetails,
                        };
                    });
                }
            }

            const untilToday = Object.keys(this.runningInvoice?.untilToday?.details?.priceDetail || {}).reduce(
                (acc, detail) => {
                    acc += this.runningInvoice?.untilToday?.details?.priceDetail?.[detail]?.price || 0;
                    return acc;
                },
                0
            );
            const endOfMonthForecast = Object.keys(
                this.runningInvoice?.endOfMonthForecast?.details?.priceDetail || {}
            ).reduce((acc, detail) => {
                acc += this.runningInvoice?.endOfMonthForecast?.details?.priceDetail?.[detail]?.price || 0;
                return acc;
            }, 0);
            this.forecastDetails = {
                invoiceDate: `${moment().startOf("month").format("YYYY, MMMM")}`,
                dateBetween: `${moment().startOf("month").format("DD MMMM, YYYY")} - ${moment()
                    .endOf("month")
                    .format("DD MMMM, YYYY")}`,
                leftTime: ` ${moment().startOf("month").add(1, "month").format("DD MMMM, YYYY")} (${moment()
                    .startOf("month")
                    .add(1, "month")
                    .endOf("day")
                    .diff(moment(), "day")} Gün sonra)`,
                untilToday: untilToday,
                endOfMonthForecast: endOfMonthForecast,
                details: result,
            };
        },
        showForecastDetails(type) {
            this.showRunningInvoiceDetails = this.showRunningInvoiceDetails !== type && type;
        },
        getPriceDetail() {
            if (!this.showRunningInvoiceDetails) return {};
            const untilPriceDetail = this.runningInvoice?.[this.showRunningInvoiceDetails]?.details?.priceDetail;
            const priceDetails = {
                price: 0,
                kdvPrice: 0,
                totalPrice: 0,
            };
            for (const type of Object.keys(untilPriceDetail)) {
                priceDetails.price += untilPriceDetail[type].price;
                priceDetails.kdvPrice += untilPriceDetail[type].taxPrice;
                priceDetails.totalPrice += untilPriceDetail[type].totalPrice;
            }
            return {
                price: Math.floor(priceDetails.price),
                kdvPrice: Math.floor(priceDetails.kdvPrice),
                totalPrice: Math.floor(priceDetails.totalPrice),
            };
        },
        formatCardType(type) {
            type = (type || "").split("_").join("");
            return type ? type[0].toUpperCase() + type.slice(1).toLowerCase() : "";
        },
        fetchInvoices() {
            getInvoices(this.perPage, this.page).then((response) => {
                this.invoices = response.data.filter((invoice) => (this.suspend ? !invoice.paid : true));
            });
        },
        paymentBill(invoiceId) {
            takePayment(invoiceId)
                .then((res) => {
                    if (res.data === true) {
                        this.$toasted.success("Fatura Başarılı bir şekilde ödendi.", {
                            duration: 3000,
                            position: "bottom-center",
                        });
                        this.invoices = this.invoices.map((i) => {
                            if (i._id === invoiceId) {
                                i.paid = true;
                                i.paymentDate = Date.now();
                            }
                            return i;
                        });

                        const unpaidInvoiceCount = this.invoices.filter((i) => !i.paid).length;
                        if (unpaidInvoiceCount === 0 && this.site.suspend) {
                            window.location.reload(); // site suspend ise ve tüm faturlar ödendi ise sayfayı reload atıyor
                        }
                    } else {
                        this.$toasted.error("Fatura ödeneme işlemi başarısız.", {
                            duration: 3000,
                            position: "bottom-center",
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$toasted.error("Fatura ödeneme işlemi başarısız.", {
                        duration: 3000,
                        position: "bottom-center",
                    });
                });
        },
        async markPaidBill(invoiceId) {
            await this.$dialog.confirm("Bu fatura ödendi diye işaretlenecek yapmak istediğinizden eminmisini?", {
                okText: "Devam Et",
                cancelText: "İptal Et",
            });
            try {
                const isSuccess = await markInvoiceAsPaid(this.site._id, invoiceId).then((res) => res.data);
                if (isSuccess) {
                    this.$message.success({
                        content: "Fatura ödendi olarak işaretlendi.",
                        key: "markpaid",
                        duration: 3,
                    });
                    this.invoices = this.invoices.map((invoice) => {
                        if (invoice._id === invoiceId) {
                            invoice.paid = true;
                            invoice.paymentDate = Date.now();
                        }
                        return invoice;
                    });
                } else {
                    this.$message.error({
                        content: "Bir hata oluştu ödendi olarak işaretlenemedi.",
                        key: "markpaid",
                        duration: 3,
                    });
                }
            } catch (error) {
                console.log(error);
                this.$message.error({
                    content: "Bir hata oluştu ödendi olarak işaretlenemedi.",
                    key: "markpaid",
                    duration: 3,
                });
            }
        },
        async deleteInvoice(invoiceId) {
            await this.$dialog.confirm(this.$t("message.deleteConfirm", { object: this.$t("billing.invoice") }), {
                okText: this.$t("message.continue"),
                cancelText: this.$t("message.cancel"),
            });
            if (this.isAdmin) {
                await forceDeleteInvoice(this.site._id, invoiceId);
            } else {
                await delInvoice(invoiceId);
            }
            this.invoices = this.invoices.filter((x) => x._id !== invoiceId);
        },
        async refundInvoice(invoiceId) {
            await this.$dialog.confirm("Bu fatura için geri ödeme işlemi yapmak istediğinizden eminmisiniz?", {
                okText: "Devam Et",
                cancelText: "İptal",
            });
            await refundInvoice(invoiceId);
            this.invoices = this.invoices.map((i) => {
                if (i._id == invoiceId) i.refund = true;
                return i;
            });
        },
        async updateCard(form) {
            if (!form.cvv || !form.fullname || !form.binNumber || !form.month || !form.year) {
                this.updatingCard = false;
                return this.$toasted.error("Tüm boş yerleri doldurmanız gereklidir.", {
                    duration: 3000,
                    position: "top-center",
                });
            }

            this.updateCardInfo({
                alias: form.cvv,
                holderName: form.fullname,
                cardNumber: form.binNumber,
                expireMonth: form.month,
                expireYear: form.year,
            })
                .then((billingDetail) => {
                    if (billingDetail) {
                        this.$toasted.success(this.$t("billing.creditCardChanged"), {
                            duration: 3000,
                            position: "top-center",
                        });
                        this.updatingCard = false;
                    } else {
                        this.$toasted.error(this.$t("billing.errorOccurred"), {
                            duration: 3000,
                            position: "top-center",
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$toasted.error(this.$t("billing.errorOccurred"), {
                        duration: 3000,
                        position: "top-center",
                    });
                    this.updatingCard = false;
                });
        },
        async updateBilling(form, toasted = true) {
            const { name, surname, idenity, taxNumber, taxOffice, mail, country, city, address, billingType } = form;
            if (
                billingType === "company"
                    ? !name || !taxOffice || !taxNumber || !mail || !country || !city || !address
                    : !name || !surname || !idenity || !mail || !country || !city || !address
            ) {
                this.updatingBilling = false;
                return this.$toasted.error("Tüm boş yerleri doldurmanız gereklidir.", {
                    duration: 3000,
                    position: "top-center",
                });
            }
            await updateBilling({
                billingType,
                name,
                surname,
                billingAddress: address,
                billingCity: city,
                billingContactName: "",
                billingCountry: country,
                email: mail,
                identityNumber: idenity,
                taxNumber,
                taxOffice,
            })
                .then((res) => {
                    if (res.data) {
                        if (toasted)
                            this.$toasted.success(this.$t("billing.billingAddressChanged"), {
                                duration: 3000,
                                position: "top-center",
                            });
                        this.setBillingDetail(res.data);
                        this.updatingBilling = false;
                    } else {
                        if (toasted) {
                            this.updatingBilling = false;
                            this.$toasted.error(this.$t("billing.errorOccurred"), {
                                duration: 3000,
                                position: "top-center",
                            });
                        }
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.updatingBilling = false;
                    this.$toasted.error(this.$t("billing.errorOccurred"), {
                        duration: 3000,
                        position: "top-center",
                    });
                });
        },
        async createInvoice(price, description, createdDate) {
            this.billModal = false;
            createInvoice(price, description, createdDate)
                .then((res) => res.data)
                .then((bill) => {
                    this.$toasted.success("Yeni Fatura başarılı bir şekilde oluşturuldu.", {
                        duration: 3000,
                        position: "top-center",
                    });
                    this.invoices = [bill, ...this.invoices];
                })
                .catch(() => {
                    this.$toasted.error("Fatura oluşturulurken bir hata oluştu.", {
                        duration: 3000,
                        position: "top-center",
                    });
                });
        },
        updateInvoicePrice(invoice) {
            updateInvoice(invoice._id, this.invoicePrice)
                .then(() => {
                    this.$toasted.success("Fatura tutarı başarılı bir şekilde güncellendi..", {
                        duration: 3000,
                        position: "top-center",
                    });
                    this.invoices = this.invoices.map((i) => {
                        if (i._id === invoice._id) i.price = this.invoicePrice;
                        return i;
                    });
                })
                .catch(() => {
                    this.$toasted.error("Fatura güncellenirken bir sorun ile karşılaştı.", {
                        duration: 3000,
                        position: "top-center",
                    });
                });
        },
        isFeature(planGroups) {
            return Object.values(planGroups.details)[0]?.plan?.type === "feature";
        },
    },
    watch: {
        showRunningInvoiceDetails: {
            handler() {
                if (this.showRunningInvoiceDetails) this.formatForecastDetails();
            },
        },
    },
    computed: {
        ...mapGetters({
            shouldSelectPlan: "setting/shouldSelectPlan",
        }),
        ...mapState({
            user: (state) => state.auth.user,
            siteId: (state) => state.site.site._id,
            authSite: (state) => state.site.site,
            billingDetail: (state) => state.site.billingDetail,
            isAdmin: (state) => state.auth.adminUser != null,
            settings: (state) => state.setting.settings,
            suspend: (state) => state.site.site.suspend,
            trialInfo: (state) => {
                const site = state.site.site;
                if (site) {
                    const { createdAt } = site;
                    const tookDays = Math.max(moment().diff(moment(createdAt, "YYYY-MM-DD"), "day"), 0);
                    const isTrial = tookDays < _.get(state.setting.settings, "plan.trialDays");
                    return {
                        trial: isTrial,
                        remainingDays: isTrial ? _.get(state.setting.settings, "plan.trialDays") - tookDays : 0,
                    };
                } else {
                    return { trial: false, remainingDays: 0 };
                }
            },
        }),
    },
};
</script>
<style lang="scss">
#billing {
    .supsis-radio {
        .ant-radio-checked .ant-radio-inner {
            border-color: rgb(236, 75, 29) !important;
        }

        .ant-radio-inner::after {
            background-color: rgb(236, 75, 29) !important;
        }

        .ant-radio-wrapper:hover .ant-radio,
        .ant-radio:hover .ant-radio-inner,
        .ant-radio-input:focus + .ant-radio-inner {
            border-color: rgb(236, 75, 29) !important;
        }
    }

    .bill-table {
        margin-bottom: 20px;

        .ant-table-thead > tr > th {
            background: transparent !important;
        }

        .ant-table-tbody > tr > td {
            border-bottom: none !important;
            background: transparent !important;
        }

        .ant-table-tbody > tr.ant-table-row-selected td {
            background: transparent !important;
        }

        .ant-checkbox-wrapper:hover .ant-checkbox-inner,
        .ant-checkbox:hover .ant-checkbox-inner,
        .ant-checkbox-input:focus + .ant-checkbox-inner {
            border-color: rgb(236, 75, 29) !important;
        }

        .ant-checkbox-indeterminate .ant-checkbox-inner::after {
            background-color: rgb(236, 75, 29) !important;
        }

        .ant-checkbox-checked .ant-checkbox-inner {
            background-color: rgb(236, 75, 29) !important;
            border-color: rgb(236, 75, 29) !important;
        }

        .ant-checkbox-input:focus + .ant-checkbox-inner {
            border-color: rgb(236, 75, 29) !important;
        }
    }
}
</style>
<style lang="scss" scoped>
#billing {
    width: 100%;
    min-height: 100vh;
    padding: 30px 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .supsis-ghost-button {
        border: 1px solid rgb(236, 75, 29);
        color: rgb(236, 75, 29);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 15px;
        border-radius: 100px;
        user-select: none;
        cursor: pointer;
        margin-top: 10px;
        background: none;
        width: 100%;
    }
    .invoice-details {
        display: grid;
        grid-template-columns: calc(50% - 5px) calc(50% - 5px);
        column-gap: 10px;
        width: 100%;

        .content {
            margin-top: 0;
            height: 100%;
        }
    }

    .billing-section {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .title-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-transform: uppercase;
            cursor: pointer;
            user-select: none;

            .title {
                font-size: 18px;
            }

            .material-icons {
                font-size: 22px;
            }
        }
        .card {
            background: white;
            border-radius: 8px;
            padding: 25px;
            border: none;
            height: 100%;
        }
    }

    .bill-search {
        background-color: rgb(236, 75, 29);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        padding: 4px 12px;
        cursor: pointer;

        .material-icons {
            font-size: 18px;
        }
    }

    .trial-information {
        width: 100%;
        background: rgb(250, 102, 102);
        padding: 10px;
        display: flex;
        align-items: center;
        color: white;
        border-radius: 4px;

        &.absolute-top {
            position: fixed;
            left: 0;
            bottom: 0;
            z-index: 999999;
            border-radius: 0;
            display: flex;
            align-items: start;
            padding: 18px;

            .material-icons.alert-icon {
                margin-right: 10px;
                font-size: 28px;
            }

            .information {
                flex-direction: column;
                align-items: start;

                .information-message {
                    font-weight: bold;
                    font-size: 18px;
                }

                .information-details {
                    display: flex;
                    flex-direction: column;

                    .information-detail {
                        display: flex;
                        align-items: center;
                        font-size: 16px;

                        .material-icons {
                            font-size: 14px;
                        }
                    }
                }
            }
        }

        .information {
            display: flex;
            align-items: center;
        }

        .skip-now {
            font-weight: bold;
            cursor: pointer;
            margin-left: 3px;
        }

        .material-icons.alert-icon {
            margin-right: 10px;
        }
    }

    .payment-method {
        width: 50px;
        height: 50px;
        margin-right: 10px;

        svg {
            width: 100%;
            height: 100%;
        }
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        color: black;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .iyzico-pay {
            width: 50px;
            height: 30px;

            svg {
                width: 50px;
                height: 30px;
            }
        }
    }

    .content {
        white-space: nowrap;
        overflow: hidden;
        transform: scale(1);
        transition: 0.3s all;
        max-height: 1000px;

        &.closed {
            transform: scale(0);
            max-height: 0px;
        }
        .current-plans {
            display: grid;
            grid-template-columns: calc(25% - (30px / 4)) calc(25% - (30px / 4)) calc(25% - (30px / 4)) calc(
                    25% - (30px / 4)
                );
            column-gap: 10px;
            row-gap: 10px;
        }

        .feature-items {
            display: grid;
            grid-template-columns: calc(25% - (30px / 4)) calc(25% - (30px / 4)) calc(25% - (30px / 4)) calc(
                    25% - (30px / 4)
                );
            column-gap: 10px;
            row-gap: 10px;
        }
    }

    .running-invoice-detail-title {
        font-weight: bold;
        font-size: 18px;
    }

    .running-invoice {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        color: black;
        position: relative;

        .running-invoice-detail {
            display: flex;
            align-items: center;
            gap: 50px;
        }

        .running-invoice-price-details {
            display: flex;
            align-items: center;
            gap: 50px;
            position: absolute;
            top: -40px;
            right: 10px;

            .running-invoice-price-detail {
                display: flex;
                flex-direction: column;
                align-items: end;

                .price {
                    font-size: 22px;
                    font-weight: bold;
                }
            }
        }
    }

    .running-invoice-details {
        margin-top: 20px;
        max-height: 1000px;
        overflow: hidden;
        transition: all 0.4s;

        &.closed {
            max-height: 0px;
        }

        .sub-item-detail {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: black;
            border-top: 1px solid #ddd;
            padding: 3px 10px;
            &.zebra {
                background: #f5f5f5;
            }

            .sub-item-name,
            .sub-item-price {
                font-weight: bold;
            }
            .sub-item-child-name {
                padding-left: 10px;
            }
            .sub-item-child-name,
            .sub-item-child-price {
                font-weight: 300;
            }
        }
        .running-invoice-details-title {
            font-size: 18px;
            font-weight: bold;
            color: black;
            margin-bottom: 5px;
        }
    }
}
</style>
